import React, { useMemo, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Button from 'components/Buttons/Button';
import { useNavigate } from 'react-router-dom';
import './styles.scss';

function SectionHeader({
  tabs, defaultTab, actions, children, hash,
}) {
  const [tab, setTab] = useState(defaultTab || tabs[0].key);
  const navigate = useNavigate();

  const tabIndex = useMemo(() => (
    tabs.findIndex(auxTab => auxTab.key === tab)
  ), [tab, tabs]);

  useEffect(() => {
    if (hash) {
      navigate({ hash: tab });
    }
  }, [hash, navigate, tab]);

  const renderActions = () => {
    const auxActions = actions || tabs[tabIndex]?.actions;
    if (!auxActions) return null;

    if (Array.isArray(auxActions)) {
      return (
        <div className='section-actions'>
          {auxActions.filter(auxAction => !auxAction.hidden).map(auxAction => <Button color='tertiary' {...auxAction} />)}
        </div>
      );
    }
    return auxActions;
  };

  return (
    <>
      <div className='section_header'>
        <div className='section-groups'>
          {tabs.map(auxTab => !auxTab.hidden && (
            <div
              key={auxTab.key}
              className={auxTab.key === tab ? 'active' : ''}
              onClick={() => setTab(auxTab.key)}
            >
              {auxTab.name}
            </div>
          ))}
          {/* <Plus size={18} /> */}
        </div>
        {renderActions()}
      </div>
      {children(tab)}
    </>
  );
}

SectionHeader.propTypes = {
  tabs: PropTypes.array.isRequired,
  actions: PropTypes.array.isRequired,
  defaultTab: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  hash: PropTypes.bool,
};

export default SectionHeader;
